(function($){

    var initializeBlock = function( $block ) {
        //console.log('video-loader-js');
        $($block).on('click', function () {
            var video = $(this).attr('data-video');
            var width = $(this).width();
            var height = $(this).height();
           var iframe = $('<iframe>').attr('src', video).attr('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; fullscreen;').attr('allowFullScreen', 'true').css({'width': width, 'height': height});
            $(this).html('').append(iframe);
            $(this).css({'height': height});
        });
    };

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.wpk-block-video-loader').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        //Dot run because it will try to load the video in the editor
        //window.acf.addAction( 'render_block_preview/type=video-loader', initializeBlock );
    }

})(jQuery);